module.exports = __webpack_public_path__ + "static/media/avatar_default.6f327df4.svg";